<template>
    <div>
        <v-chip
            v-for="(file, idx) in files"
            :key="idx"
            label
            small
            link
            class="pl-1 mr-2 mb-2 attachment-chip font-weight-medium"
            :color="color"
            :close="canDelete"
            close-icon="$XCircle    "
            @click="$emit('download', file)"
            @click:close="delete_file(file)"
        >
            <span :class="['px-2 mr-2 attachment-ext ', $options.filters.file_color(file.file_name, true)]">
                {{ file.file_name | file_extension }}
            </span>
            <span class="attachment-name">
                {{ file.file_name | file_name_max_len(30) }}
            </span>
            <v-progress-circular
                v-if="file.uploading"
                indeterminate
                color="primary"
                :size="16"
                class="ml-2"
                :width="2"
            ></v-progress-circular>
        </v-chip>
    </div>
</template>

<script>
import Vue from "vue";
import { $t } from "@/i18n";
import axios from 'axios'
import DialogModule from "../store/modules/dialog";

export default {
    name: "AttachmentsList",
    props: {
        files: {
            type: Array,
            required: true
        },
        canDelete: {
            type: Boolean,
            default: true
        },
        color: {
            type: String,
            default: "n1"
        }
    },
    setup(props, ctx) {
        const dialogModule = DialogModule();
        let file_to_deleted = null;

        const delete_file = function(file) {

            file_to_deleted = file;
            dialogModule.setConfirmOptions({
                title: $t("Are you sure to delete this attachment?"),
                confirm_text: $t("Delete"),
                cancel_text: $t("Cancel"),
                action: delete_file_confirmed
            });
            dialogModule.openConfirmDialog();
        };
        const delete_file_confirmed = function() {
            ctx.emit("delete_file", file_to_deleted);
        };
        return {
            delete_file
        };
    }
};
</script>
<style lang="scss" scoped>
::v-deep .v-chip {
    color: var(--v-n5-base);

    .v-icon:before {
        visibility: hidden;
        color: var(--v-primary-base) !important;
    }

    &:hover {
        color: var(--v-primary-base);

        .v-icon:before {
            visibility: visible;
        }
    }
}
</style>
